import * as actions from '../constants/actions';

const initialApiLatencyState = {
	loading: false,
	error: null,
	status: 'Offline',
	current: null,
	longest: null
};

export const initialState = {};

const getPrevData = (state, id) => {
	if (state.hasOwnProperty(id)) {
		return { ...state[id] };
	}

	return { ...initialApiLatencyState };
};

export default (state = initialState, action) => {
	switch (action.type) {

		case actions.NETWORKHEALTH_ADD_SERVICES: {
			const newState = action.payload.reduce((aggregateState, service) => {
				if (aggregateState.hasOwnProperty(service.id)) {
					return aggregateState;
				}
				return {
					...aggregateState,
					[service.id] : {
						...initialApiLatencyState
					}
				};
			}, state);
			return newState;
		}

		case actions.NETWORKHEALTH_REMOVE_SERVICES: {
			let newState = { ...state };
			action.payload.forEach(service => {
				delete newState[service.id];
			});
			return newState;
		}
		
		case actions.NETWORKHEALTH_API_LATENCY_ERROR: {
			const id = action.payload.id;
			const prevData = getPrevData(state, id);
			const error = action.payload.error;
			let status = 'Error';
			if (!error.status) {
				status = 'Offline'
			}
			return {
				...state,
				[id]: {
					...prevData,
					current: null,
					status,
					error: error.message || error
				}
			};
		}

		case actions.NETWORKHEALTH_API_LATENCY_LOADING: {
			const id = action.payload.id;
			const prevData = getPrevData(state, id);
			return {
				...state,
				[id]: {
					...prevData,
					loading: action.payload.loading
				}
			};
		}

		case actions.NETWORKHEALTH_UPDATE_API_LATENCY: {
			const id = action.payload.id;
			const data = { ...action.payload.data };
			const prevData = getPrevData(state, id);
			const longest = prevData.longest || data;

			return {
				...state,
				[id]: {
					...prevData,
					status: 'Online',
					error: null,
					current: data,
					longest: longest.latency > data.latency ? longest : data
				}
			};
		}

		default:
			return state;

	}
};


// WEBPACK FOOTER //
// ./src/reducers/apiLatencies.js